
const { ccclass, menu, property, inspector } = cc._decorator;

@ccclass
@menu('custom/customToggle')
@inspector('packages://customtoggle-inspector/inspector.js')
export default class CustomToggle extends cc.Toggle {
    @property(cc.Label)
    targetLabel: cc.Label = null

    @property(cc.Color)
    selectedlColor: cc.Color = cc.Color.WHITE

    @property(cc.Color)
    unSelectedColor: cc.Color = cc.Color.RED


    _updateCheckMark(){
        super['_updateCheckMark']()
        this.targetLabel && (this.targetLabel.node.color = this.isChecked? this.selectedlColor: this.unSelectedColor)
    }

}